import { TFunction } from "i18next";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  DATE_FORMAT_YMD,
  getDateUnitForCalendarMode,
  nowInTimezone,
  TOP_CALENDAR_MODES,
  useTimezone,
  type ITopCalendarDropdownRow,
  type TimeZoneEnum,
  type TopCalendarMode,
} from "@ryde/shared";

interface IAddCalendarItemArguments {
  weekendStart: number;
  weekendDuration: number;
  mode: TopCalendarMode;
  t: TFunction;
  timezone: TimeZoneEnum;
}

export interface IUseRideCalendarItems {
  dropdownItems: ITopCalendarDropdownRow[];
}

const addCalendarItem = ({
  mode,
  t,
  weekendStart,
  weekendDuration,
  timezone,
}: IAddCalendarItemArguments): ITopCalendarDropdownRow => {
  return {
    value: mode,
    label: t(`general.calendar.${mode}`),
    datesUnit: getDateUnitForCalendarMode({
      mode,
      weekendDuration,
      weekendStart,
      timezone,
    }),
  };
};

export const useTopCalendarItems = ({
  weekendStart,
  weekendDuration,
}: {
  weekendStart: number;
  weekendDuration: number;
}): IUseRideCalendarItems => {
  const { t } = useTranslation();
  const { timezone } = useTimezone();
  const calendarDay = nowInTimezone(timezone).format(DATE_FORMAT_YMD);
  const dropdownItems = useMemo(() => {
    void calendarDay;
    return TOP_CALENDAR_MODES.map(mode => {
      return addCalendarItem({
        mode,
        t,
        weekendStart,
        weekendDuration,
        timezone,
      });
    });
  }, [calendarDay, t, timezone, weekendDuration, weekendStart]);

  return { dropdownItems };
};
